import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import EditAIIcon from "../../../../../../assets/common/icons/edit-ai.svg";
import styles from "./TgModelEvaluationEmptyState.module.scss";

const TgModelEvaluationEmptyState = () => {
	const { t } = useTranslation("tg", { keyPrefix: "models.viewer.evaluation.emptyState" });

	return (
		<Box className={styles.root}>
			<img className={styles.icon} src={EditAIIcon} />
			<Typography className={styles.title}>{t("title")}</Typography>
			<Typography className={styles.description}>{t("description")}</Typography>
		</Box>
	);
};

export default observer(TgModelEvaluationEmptyState);
